export enum AudioDownloadRenderingStatus {
  Finished = 'finished',
  Processing = 'processing',
}

export interface AudioDownloadRenderingFinished {
  status: AudioDownloadRenderingStatus.Finished;
  downloadUrl: string;
}

export interface AudioDownloadRenderingProcessing {
  status: AudioDownloadRenderingStatus.Processing;
  message: string;
}

export type AudioDownloadRendering =
  | AudioDownloadRenderingFinished
  | AudioDownloadRenderingProcessing;
